import { createElement } from "react";
import SamiSpin from "components/SamiSpin";

/* The suite loader — Sami's mark, working — registered as <semi360-loader> by
   the Hub header bundle this app already mounts. The lucide ring survives as
   the element's light-DOM child: an undefined custom element renders its
   children, so a page that never loads the header degrades to the spinner it
   had, and upgrades in place the moment header.js lands. */
const LoadingComponent = ({ message = "Loading..." }) => {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[100]">
      <div className="bg-white rounded-lg p-6 flex flex-col items-center shadow-lg">
        {createElement(
          "semi360-loader",
          { label: message, size: "48" },
          <SamiSpin className="animate-spin text-s360-violet" size={32} />,
        )}
      </div>
    </div>
  );
};

export default LoadingComponent;
